import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-between items-center q-mb-lg" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "page-subtitle" }, "Postback list", -1)
const _hoisted_3 = { class: "q-mb-lg" }
const _hoisted_4 = { class: "row flex items-center" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "postback-block__checkboxes" }
const _hoisted_7 = { class: "postback-block__remove" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_option_group = _resolveComponent("q-option-group")!
  const _component_PostbackNoteDialog = _resolveComponent("PostbackNoteDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_q_btn, {
        onClick: _ctx.addPostback,
        class: "q-btn__main-size text-weight-bold",
        color: "primary",
        "icon-right": "add",
        label: _ctx.$t('add_postback'),
        unelevated: "",
        "no-caps": ""
      }, null, 8, ["onClick", "label"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.postbacks, (postback, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "postback-block q-mb-sm q-py-xs q-px-lg",
          key: index
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_q_input, {
                outlined: "",
                label: "Postback",
                "stack-label": "",
                dense: "",
                class: "col-12 link-text q-mr-md postback-block__input text-weight-bold",
                style: {"padding-top":"20px"},
                placeholder: _ctx.$t('link'),
                modelValue: postback.url,
                "onUpdate:modelValue": ($event: any) => ((postback.url) = $event),
                error: !!_ctx.errors?.postbacks,
                "error-message": _ctx.errors?.postbacks
              }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue", "error", "error-message"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_q_option_group, {
                modelValue: postback.types,
                "onUpdate:modelValue": ($event: any) => ((postback.types) = $event),
                options: _ctx.postbackTypes,
                color: "primary",
                type: "checkbox",
                inline: ""
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_q_btn, {
                "no-caps": "",
                onClick: ($event: any) => (_ctx.removePostback(index)),
                flat: "",
                size: "11px",
                class: "q-pa-none",
                disable: _ctx.postbacks.length < 2,
                "icon-right": _ctx.heroOutline24Trash
              }, null, 8, ["onClick", "disable", "icon-right"])
            ])
          ])
        ]))
      }), 128)),
      _createVNode(_component_PostbackNoteDialog, {
        open: _ctx.showPostbackNoteDialog,
        onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showPostbackNoteDialog = false))
      }, null, 8, ["open"])
    ])
  ], 64))
}